












import Vue from 'vue';
import { ITeaserDot } from '../../../../common/interfaces/products.interface';
import { IStyleObject } from '@/common/interfaces/index.interface';

export default Vue.extend({
  name: `TeaserDot`,
  computed: {
    teaserDotStyle(): IStyleObject {
      return {
        backgroundColor: this.teaserDot.backgroundColor,
        borderColor: this.teaserDot.borderColor,
        color: this.teaserDot.textColor,
      };
    },
    teaserDotTextStyle(): IStyleObject {
      return {
        fontSize: `${this.teaserDot.fontSize}px`,
        lineHeight: `${this.teaserDot.fontSize * this.teaserDot.lineHeight}px`,
      };
    },
  },
  props: {
    teaserDot: {
      required: true,
      type: Object as () => ITeaserDot,
    },
  },
});
